import {
  FeatureSetsDerivedFromRequest,
  FeatureSetsDerivedFromResponse,
} from './gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { OnlineIngestionRequest } from './gen/ai/h2o/featurestore/api/v1/OnlineApi.pb';
import * as fm from './gen/fetch.pb';
import { NameValue } from './models';

// Online Ingestion
// /online/api/v1/ingestion/feature-sets/{featureSetId}/{featureSetMajorVersion}

interface OnlineIngestionExtRequest extends OnlineIngestionRequest {
  featureSetId?: string;
  featureSetMajorVersion?: string;
}

interface OnlineIngestionResponse {
  errors?: string;
}

export interface OnlineRetrieveRequest {
  token?: string;
  signature?: string;
  keys?: NameValue[];
}

interface OnlineRetrieveExtRequest extends OnlineRetrieveRequest {
  featureSetId?: string;
  featureSetMajorVersion?: string;
}

interface OnlineRetrieveResponse {
  row?: string;
}

export class FeatureStoreService {
  static OnlineIngestion(req: OnlineIngestionExtRequest, initReq?: fm.InitReq): Promise<OnlineIngestionResponse> {
    const { featureSetId, featureSetMajorVersion, ...newReq } = req;
    return fm.fetchReq<OnlineIngestionRequest, OnlineIngestionResponse>(
      `/online/api/v1/ingestion/feature-sets/${featureSetId}/${featureSetMajorVersion}`,
      { ...initReq, method: 'POST', body: JSON.stringify(newReq, fm.replacer) }
    );
  }
  static OnlineRetrieve(req: OnlineRetrieveExtRequest, initReq?: fm.InitReq): Promise<OnlineRetrieveResponse> {
    const { featureSetId, featureSetMajorVersion, keys = [], ...newReq } = req;
    const keyValueParams = keys.length ? `&${keys.map(({ value = '' }) => `key=${value}`).join('&')}` : '';
    return fm.fetchReq<OnlineRetrieveRequest, OnlineRetrieveResponse>(
      `/online/api/v1/retrieve/feature-sets/${featureSetId}}/${featureSetMajorVersion}?${fm.renderURLSearchParams(
        newReq as Record<string, unknown>,
        []
      )}${keyValueParams}`,
      { ...initReq, method: 'GET' }
    );
  }
  static GetFeatureSetsDerivedFrom(
    req: FeatureSetsDerivedFromRequest,
    initReq?: fm.InitReq
  ): Promise<FeatureSetsDerivedFromResponse> {
    return fm.fetchReq<FeatureSetsDerivedFromRequest, FeatureSetsDerivedFromResponse>(
      `/api/v1/feature-sets/${req['featureSetId']}/versions/${
        req['featureSetMajorVersion']
      }/derived-from?${fm.renderURLSearchParams(req, ['featureSetId'])}`,
      { ...initReq, method: 'GET' }
    );
  }
}
